import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@restaurant.com");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) {
      toast.success("Welcome back!");
      nav("/");
    }
  };

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4"
      style={{
        background:
          "radial-gradient(circle at 20% 20%, #FCE9DF 0%, #F9F8F6 45%, #F5F2EF 100%)",
      }}
      data-testid="login-page"
    >
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <img
            src="/logo-final.jpeg"
            alt="Order Raja"
            className="w-11 h-11 rounded-xl object-cover shadow-sm"
          />
          <div>
            <div className="font-heading font-extrabold text-2xl tracking-tight text-[#2D2C2A]">
              Order Raja
            </div>
            <div className="text-sm text-[#7A7873]">Har Order Ka Raja.</div>
          </div>
        </div>

        <div className="bg-white border border-[#EBE8E2] rounded-xl p-8 shadow-sm">
          <h1 className="font-heading font-bold text-2xl text-[#2D2C2A] mb-1">
            Sign in
          </h1>
          <p className="text-sm text-[#7A7873] mb-6">
            Welcome back. Please enter your credentials.
          </p>

          <form
            onSubmit={submit}
            className="space-y-4"
            data-testid="login-form"
          >
            <div>
              <Label
                htmlFor="email"
                className="text-sm text-[#2D2C2A] font-medium"
              >
                Email
              </Label>
              <div className="mt-1.5 relative">
                <Mail
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7A7873]"
                  size={16}
                />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="pl-9 h-11 border-[#EBE8E2] focus-visible:ring-[#D95D39]"
                  data-testid="login-email-input"
                />
              </div>
            </div>

            <div>
              <Label
                htmlFor="password"
                className="text-sm text-[#2D2C2A] font-medium"
              >
                Password
              </Label>
              <div className="mt-1.5 relative">
                <Lock
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7A7873]"
                  size={16}
                />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="pl-9 h-11 border-[#EBE8E2] focus-visible:ring-[#D95D39]"
                  data-testid="login-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-11 bg-[#D95D39] hover:bg-[#C24F2C] text-white font-semibold tracking-wide active:scale-[0.98] transition"
            >
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>

          <div className="mt-6 p-3 rounded-lg bg-[#F4F2EE] text-xs text-[#7A7873] leading-relaxed">
            <div className="font-semibold text-[#2D2C2A] mb-1">
              Demo accounts
            </div>
            <div>Admin: admin@restaurant.com / admin123</div>
            <div>Manager: manager@restaurant.com / password123</div>
            <div>Cashier: cashier@restaurant.com / password123</div>
          </div>
        </div>

        <div className="text-center text-xs text-[#7A7873] mt-6">
          © 2026 Order Raja · Har Order Ka Raja
        </div>
      </div>
    </div>
  );
}
